import { InjectionToken } from "@angular/core";
import { routerReducer } from "@ngrx/router-store";
import { ActionReducerMap, MetaReducer } from "@ngrx/store";
import { environment } from "../../environments/environment";

export const reducers: ActionReducerMap<Record<string, unknown>> = {
  router: routerReducer,
};

export const REDUCERS_TOKEN = new InjectionToken<
  ActionReducerMap<Record<string, unknown>>
>(`App Reducers`);
export const reducerProvider = { provide: REDUCERS_TOKEN, useValue: reducers };

export const metaReducers: MetaReducer<Record<string, unknown>>[] =
  !environment.production ? [] : [];
